import { Col, DatePicker, Form, FormInstance, Select } from "antd";
import {
  BEGINNING_PRINCIPAL_MAX_MSG,
  DATE_FORMAT,
} from "../../../../../../../../lib/constants";
import { ACCOUNT_PAYMENT_TYPES } from "../../../../../../../../lib/constants";
import { FloatNumberInput } from "../../../../../../../../components/FloatNumberInput";
import { useCallback, useMemo } from "react";
import { Rule } from "antd/es/form";
import { useGetBeginningDateRules } from "../../../../../../../Accounts/components/Filters/hooks/useGetBeginningDateRules";
import { useCalculateInterestPerDiem } from "../../hooks/calculateInterestPerDiem";
import { transformToFloat } from "../../../../../../../../lib/transformToFloat";

type LeftFormColProps = {
  form: FormInstance;
  isBeginningPrincipalDisabled: boolean;
};

export const LeftFormCol = ({
  form,
  isBeginningPrincipalDisabled,
}: LeftFormColProps) => {
  const MAX_BEGINNING_PRINCIPAL_RULE = 1000000000;

  const { calculate } = useCalculateInterestPerDiem(form);

  const { rules: beginningDateRules } = useGetBeginningDateRules();

  const beginningPrincipalRule: Rule[] = useMemo(() => {
    return [
      () => ({
        validateTrigger: "onSubmit",
        validator(_: Rule, value: string) {
          const val: number | null = transformToFloat(value);
          if (!val || +val <= MAX_BEGINNING_PRINCIPAL_RULE) {
            return Promise.resolve();
          }
          return Promise.reject(new Error(BEGINNING_PRINCIPAL_MAX_MSG));
        },
      }),
    ];
  }, []);

  const onBeggingPrincipalChange = useCallback(() => {
    const val = form.getFieldValue("beginningPrincipal");

    form.setFieldValue("balancePrincipal", val);
    calculate();
  }, [form, calculate]);

  return (
    <Col className="general-info-col mr-7">
      <Form.Item
        label="Beginning Date"
        name={"beginningDate"}
        className="mb-4 balance__form-item"
        rules={beginningDateRules}
      >
        <DatePicker format={DATE_FORMAT} placeholder="MM/DD/YY" />
      </Form.Item>

      <FloatNumberInput
        name={"beginningPrincipal"}
        label="Beginning Principal"
        className="mb-4"
        form={form}
        rules={beginningPrincipalRule}
        onChange={onBeggingPrincipalChange}
        includeThousandsSeparator
        disabled={isBeginningPrincipalDisabled}
      />

      <Form.Item
        label="	Balance Due Date"
        name={"balanceDueDate"}
        className="mb-4 balance__form-item"
      >
        <DatePicker format={DATE_FORMAT} placeholder="MM/DD/YY" />
      </Form.Item>

      <Form.Item label="Payment Type" name={"paymentType"}>
        <Select options={ACCOUNT_PAYMENT_TYPES} />
      </Form.Item>
    </Col>
  );
};
